<template>
    <div class="news_home">

        <HeadImg :msg="titleName" :url="imgMajors"></HeadImg>


        <div class="new1" id="new1">
            <div class="n1_cont">
                <div class="section_title">
                    <p class="section_cn">热门国家申请攻略</p>
                    <p class="section_en">APPLICATION REQUIREMENTS</p>
                </div>

                <div class="n1_nav_box">
                    <div class="n1_nav_item" @click="switchCountry(0)">
                        <p>英国</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(1)">
                        <p>美国</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(2)">
                        <p>日本</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(3)">
                        <p>德国</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(4)">
                        <p>加拿大</p>
                    </div>
                    <div class="n1_nav_item" @click="switchCountry(5)">
                        <p>澳大利亚</p>
                    </div>

                </div>
                <div class="n1_main">
                    <div class="n1_main_hid2"></div>
                    <div class="n1_main_hid"></div>
                    <div class="n1_main_show">
                        <div class="n1_main_li_box">
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Frame.png" alt="">
                                <p>申请时间：</p>
                                <div>{{ theCountryData.time }}</div>
                            </div>
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 541.png" alt="">
                                <p>语言要求：</p>
                                <div>{{ theCountryData.language }}</div>
                            </div>
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 542.png" alt="">
                                <p>申请材料：</p>
                                <div>{{ theCountryData.writ }}</div>
                            </div>
                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 543.png" alt="">
                                <p>绩点要求：</p>
                                <div>{{ theCountryData.gpa }}</div>
                            </div>

                            <div class="n1_main_li">
                                <img src="../img/留学资讯切图/Group 544.png" alt="">
                                <p>文书要求：</p>
                                <div>{{ theCountryData.material }}</div>
                            </div>

                        </div>
                        <div class="n1_main_bottom_box">

                            <!-- <div >
                                <p>即刻咨询</p>
                                <img src="../img/留学资讯切图/Group 545.png" alt="">
                            </div> -->
                            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                <div class="n1_main_bottom_item2" @mouseenter="moreEnter" @mouseleave="moreLeave">
                                    <p id="n1_main_bottom_item_p2">了解更多</p>
                                    <img src="../img/热门专业切图/Group 522.png" alt="">
                                </div>
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div class="new2">
            <div class="new2_nav_box">
                <div class="new2_nav_item" @click="switchNews(0, 0)">全部资讯</div>
                <div class="new2_nav_item" @click="switchNews(1, 1)">院校及专业</div>
                <div class="new2_nav_item" @click="switchNews(30, 2)">导师经验说</div>
                <div class="new2_nav_item" @click="switchNews(10, 3)">学生分享</div>
                <div class="new2_nav_item" @click="switchNews(3, 4)">热门活动</div>
                <div class="new2_nav_item" @click="switchNews(2, 5)">留学攻略</div>
            </div>
            <div class="n2_cont">
                <!-- <keep-alive> -->
                    <div class="n2_left">
                        <div class="n2_left_item_box">
                            <div class="n2_left_item" v-for="(item, index) in artsNewsData" @click="newsDetail(item.id)">
                                <div class="n2_item_imgBox">
                                    <img :src="'https://public.rossoarts.com/static/uploads/article/' + item.list_img"
                                        alt="">
                                </div>
                                <div class="n2_item_title">{{ item.title }}</div>
                                <p>{{ item.create_time }}</p>
                            </div> 

                        </div>
                        <div class="n2_page">
                            <el-pagination layout="prev, pager, next" :total="qaTotal" @current-change="handelPage">
                            </el-pagination>
                        </div>
                    </div>
                <!-- </keep-alive> -->
                <div class="n2_right">
                    <h2>艺术留学评估</h2>
                    <div class="n2_right_p2">*个人优势、作品集评估、留学院校及专业推荐一站解答</div>
                    <el-form :model="formLabelAlign" class="demo-form-inline">
                        <el-form-item label="姓名:">
                            <el-input v-model="formLabelAlign.name" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="电话:">
                            <el-input v-model="formLabelAlign.tel" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="专业:">
                            <el-select v-model="formLabelAlign.major" placeholder="">
                                <el-option label="服装设计" value="服装设计"></el-option>
                                <el-option label="插画设计" value="插画设计"></el-option>
                                <el-option label="平面设计" value="平面设计"></el-option>
                                <el-option label="室内设计" value="室内设计"></el-option>
                                <el-option label="建筑设计" value="建筑设计"></el-option>
                                <el-option label="其他专业" value="其他专业"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="n2_sub_btn" @click="onSubmit">
                        <p>即刻咨询</p>
                        <img src="../img/留学资讯切图/Group 549.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <!-- 最外层div -->
    </div>
</template>

<script>
import HeadImg from '@/components/HeadImg.vue'
import imgMajors from '@/img/留学资讯切图/Rectangle 142.jpg'
import "@/assets/css/news.css"
import axios from "axios"
export default {
    components: {
        HeadImg
    },
    data() {
        return {
            imgMajors,
            titleName: {
                cname: "留学资讯",
                ename: "ART NEWS"
            },
            countryData: [
                {
                    time: "11月至次年1月",
                    material: "作品集、1-2本sketchbook",
                    language: "雅思5.5分以上/托福80分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "10月中旬至次年1月中旬",
                    material: "作品集、语言成绩、SAT／ACT",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },

                {
                    time: "9月至次年2月",
                    material: "文书材料、作品集、日语成绩、大学成绩单",
                    language: "日语，成绩需要达到 N1/300分以上",
                    gpa: "大部分院校要求3.2以上",
                    writ: "包括研究计划（论文）、成绩证明书、推荐信等，具体以学校要求为准"
                },
                {
                    time: "12月至次年5月",
                    material: "作品集、德语证明、表格式简历、本科毕业证和学位证",
                    language: "德语，申请时达到B1，入学时达到C1",
                    gpa: "大部分院校要求3.2以上",
                    writ: "具体以学校要求为准"
                },
                {
                    time: "12月至次年2月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "8月至12月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
            ],
            theCountryData: {
                time: "11月至次年1月",
                material: "作品集、1-2本sketchbook",
                language: "雅思5.5分以上/托福80分以上",
                gpa: "大部分院校要求3.0以上",
                writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
            },
            new1Bgc: [
                require("../img/留学资讯切图/yg.jpg"),
                require("../img/留学资讯切图/mg.jpg"),
                require("@/img/留学资讯切图/rb.jpg"),
                require("@/img/留学资讯切图/dg.jpg"),
                require("@/img/留学资讯切图/jnd.jpg"),
                require("@/img/留学资讯切图/adly.jpg"),
            ],
            qaTotal: 0,
            qaPage: 1,
            artsNewsData: [],
            artsNewClass: 0,
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                major: '',
            },
        }
    },
    created() {
        this.getArtsNews()
    },
    methods: {
        newsDetail(val) {
            // window.open(`https://public.rossoarts.com/news/${val}.html`,"_blank")
            this.$router.push(`/news/${val}.html`)
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            // console.log('submit!',this.formInline);
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "url": window.location.href,
                        "status": status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        switchNews(val, val2) {

            this.artsNewClass = val
            this.qaPage = 1
            this.getArtsNews()
            var new2_nav_item = document.getElementsByClassName("new2_nav_item")
            for (var i = 0; i < new2_nav_item.length; i++) {
                new2_nav_item[i].style.backgroundColor = "transparent"
                new2_nav_item[i].style.color = "#000"
            }
            new2_nav_item[val2].style.backgroundColor = "#5F9DF7"
            new2_nav_item[val2].style.color = "#fff"
        },
        handelPage(val) {
            // console.log(val);
            this.qaPage = val
            this.getArtsNews()
        },
        getArtsNews() {
            axios.get(`https://public.rossoarts.com/api/v1/getArtsNews?category=${this.artsNewClass}&limit=7&page=${this.qaPage}`).then((data) => {
                // console.log(data.data.data.data);
                // for(var i=0;i<data.data.data.data.length;i++){
                //     if(data.data.data.data[i].title.indexOf("爱德思") == 0){
                //         console.log(data.data.data.data[i].id);
                //     }else{
                //         console.log("wu");
                //     }
                // }


                this.artsNewsData = data.data.data.data
                this.qaTotal = data.data.data.total

            })
        },
        switchCountry(val) {
            // console.log(val);
            var n1_nav_item = document.getElementsByClassName("n1_nav_item")
            var new1 = document.getElementsByClassName("new1")
            for (var i = 0; i < n1_nav_item.length; i++) {
                n1_nav_item[i].style.backgroundColor = "transparent"
            }

            n1_nav_item[val].style.backgroundColor = "#FB6333"
            this.theCountryData = this.countryData[val]
            new1[0].style.backgroundImage = `url(${this.new1Bgc[val]})`
        },
        moreEnter() {
            // console.log("666");
            n1_main_bottom_item_p2.style.width = "260px"
            n1_main_bottom_item_p2.innerHTML = '申请流程、留学费用、院校推荐...'
        },
        moreLeave() {
            n1_main_bottom_item_p2.style.width = "78px"
            n1_main_bottom_item_p2.innerHTML = '了解更多'
        },

    }
}
</script>